<template>
  <div class="popup-block"
       :class="{opened: shown}">
    <template>
      <transition name="fade_popup">
        <div
          v-show="shown_transition"
          class="popup-block_shadow"
          @click="closeModal">
        </div>
      </transition>
      <transition name="slide_popup">
        <div
          v-show="shown_transition"
          class="popup-block_el"
          :class="class_list">
          <div class="popup-block_el-content">
            <div class="popup-block_el-content-header">
              <div class="popup-block_el-content-header-title">
                <slot name="popup_title"/>
              </div>
              <div
                @click="closeModal"
                class="popup-block_el-content-header-close cursor_pointer">
                <close-icon/>
              </div>
            </div>
            <div v-show="has_sub_title" class="popup-block_el-content-header-sub_title">
              <slot name="popup_sub_title"/>
            </div>
            <div v-if="head_status_text" class="px-4">
              <div class="alert"
                   :class="header_status_error ? 'alert-danger' : 'alert-success'"
                   role="alert">
                {{ head_status_text }}
              </div>
            </div>
            <div class="popup-block_el-content-body" ref="content_body">
              <slot/>
            </div>
            <div
              v-show="has_popup_footer"
              class="popup-block_el-content-footer">
              <slot name="popup_footer"/>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import CloseIcon from "../icons/CloseIcon";
export default {
  name: 'PopupBlock',
  components: {CloseIcon},
  props: {
    shown: {
      type: Boolean,
      default: false,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    is_wide: {
      type: Boolean,
      default: false,
    },
    is_wider: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false
    },
    head_status_text: {
      type: String,
      default: ''
    },
    header_status_error: {
      type: Boolean,
      default: false
    },
    emit_scroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      local_shown: false,
      shown_transition: false,
      timeout_f: false
    }
  },
  computed: {
    has_popup_footer() {
      return !!this.$slots.popup_footer
    },
    has_sub_title() {
      return !!this.$slots.popup_sub_title
    },
    class_list() {
      return {
        wide: this.is_wide,
        wider: this.is_wider
      }
    }
  },
  mounted() {
    if (!this.emit_scroll) return
    this.$refs.content_body.addEventListener('scroll', this.scrollEvent)
  },
  methods: {
    closeSiblingsModals() {
      let el = document.querySelector('.popup-block.opened')
      if (el?.__vue__?.shown) {
        el.__vue__.closeModal()
      }
    },
    keyupWatcher(event) {
      if (event.key === 'Enter') {
        this.$emit('submit')
      }
      if (event.key === 'Escape') {
        this.$emit('close')
      }
    },
    initEnterWatch() {
      document.addEventListener("keyup", this.keyupWatcher);
    },
    deleteEscapeWatch() {
      document.removeEventListener('keyup', this.keyupWatcher)
    },
    scrollEvent(e) {
      this.$emit('scroll', e)
    }
  },
  beforeDestroy() {
    this.deleteEscapeWatch()
    this.$refs.content_body.removeEventListener('scroll', this.scrollEvent)
  },
  watch: {
    shown(newVal) {
      if (newVal) {
        clearTimeout(this.timeout_f)
        this.closeSiblingsModals()
        this.local_shown = true
        this.initEnterWatch()
      } else {
        this.deleteEscapeWatch()
        this.timeout_f = setTimeout(() => {
          this.local_shown = false
        }, 300)
      }
      this.$nextTick(() => {
        this.shown_transition = newVal
      })
      document.body.style.overflow = newVal ? 'hidden' : 'unset'
    }
  }
}
</script>
